import { RemoteSourceRow } from 'components/tables/data/remote-source/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the remote source ID.
 */
export default function RemoteSourceIdColumn({ data: { remoteSourceId } }: { data: RemoteSourceRow }) {
  return <P3Regular color="gray.8">{remoteSourceId}</P3Regular>;
}
